"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LANDING_NAME = exports.LANDING_PAGES_IDS = exports.TEXT_ELEMENT_STYLE = exports.ELEMENT_TYPE = void 0;
exports.ELEMENT_TYPE = {
    SECTION: 'landing-editor-section',
};
exports.TEXT_ELEMENT_STYLE = {
    LINE_HEIGHT: 'lineHeight',
    FONT_SIZE: 'fontSize',
    LETTER_SPACING: 'letterSpacing',
    FONT_STYLE: 'fontStyle',
    FONT_FAMILY: 'fontFamily',
    TEXT_DECORATION: 'textDecoration',
    FONT_WEIGHT: 'fontWeight',
    ALIGNMENT: 'textAlign',
    COLOR: 'color',
};
exports.LANDING_PAGES_IDS = {
    STANDARD_PAGE: 'STANDARD',
};
exports.DEFAULT_LANDING_NAME = 'NEW LANDING';
